import React, { useCallback, useMemo } from 'react';
import { IEditorProps } from './Editor';
import { EditorLabel } from './EditorLabel';
import { EditorValidationWrapper } from './EditorValidationWrapper';
import { getChildValueAsArray } from 'components/property-editors/utils/ProviderNodeUtils';
import { OutcomeScenarioLinkButton } from './OutcomeScenarioLinkButton';
import { ListBoxEmptyMessage } from '../lists/ListBoxEmptyMessage';
import classNames from 'classnames';
import './OutcomeScenariosEditor.less';
import { OutcomeScenario } from '@decisions/server/DecisionsFramework/ServiceLayer/OutcomeScenario';
import { OutcomeType } from '@decisions/server/DecisionsFramework/ServiceLayer/OutcomeType';

export const OUTCOME_EDITOR_CLASS_NAME = 'dpc-outcome-editor';

const getClassName = (value: OutcomeScenario[]) =>
  classNames(value && value.length > 0 ? OUTCOME_EDITOR_CLASS_NAME : `${OUTCOME_EDITOR_CLASS_NAME}--empty`);

const getLabelClassName = (outcomeType: OutcomeType) =>
  classNames(`${OUTCOME_EDITOR_CLASS_NAME}__content-label`, {
    [`${OUTCOME_EDITOR_CLASS_NAME}__required`]: outcomeType === OutcomeType.Required,
    [`${OUTCOME_EDITOR_CLASS_NAME}__optional`]: outcomeType === OutcomeType.Optional,
    [`${OUTCOME_EDITOR_CLASS_NAME}__notused`]: outcomeType === OutcomeType.NotUsed,
  });

export function OutcomeScenariosEditor({ child, path, onChange }: IEditorProps) {
  const childValue: OutcomeScenario[] = getChildValueAsArray(child);

  const handleChange = useCallback(
    (outcomeScenario: OutcomeScenario) => {
      const indexValue = childValue.findIndex(s => s.OutcomePath === outcomeScenario.OutcomePath);
      if (indexValue != null) {
        childValue[indexValue].OutcomeType = outcomeScenario.OutcomeType;
        onChange(childValue, path);
      }
    },
    [childValue, onChange, path]
  );

  const getOutcomeScenarioLinkButtonView = useMemo(() => {
    return childValue.map((item, i) => (
      <OutcomeScenarioLinkButton
        key={i}
        outcomeScenario={item}
        onSelect={handleChange}
        labelClassName={getLabelClassName(item.OutcomeType)}
      />
    ));
  }, [childValue, handleChange]);
  return (
    <EditorLabel editor={child} path={path} hideInputLabel={true}>
      <EditorValidationWrapper editor={child}>
        <div className={getClassName(childValue)}>
          {childValue.length > 0 && getOutcomeScenarioLinkButtonView}
          <ListBoxEmptyMessage text="no outcome paths" list={childValue} />
        </div>
      </EditorValidationWrapper>
    </EditorLabel>
  );
}
